import { render, staticRenderFns } from "./DeltaCard.vue?vue&type=template&id=f56f7274&scoped=true&"
import script from "./DeltaCard.vue?vue&type=script&lang=js&"
export * from "./DeltaCard.vue?vue&type=script&lang=js&"
import style0 from "./DeltaCard.vue?vue&type=style&index=0&id=f56f7274&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f7274",
  null
  
)

export default component.exports